// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"222":"aa73a1e05a48c1d9","758":"fede4a2657f5d6b5"}[chunkId] + ".css";
};